<script setup lang="ts">
import Mdi from '@/corePagesModule/components/Mdi.vue';

/**
 * 設定ホームで表示するカードのプロパティ
 */
type Props = {
  /** 遷移先のパス */
  to: string;
  /** カードのタイトル */
  title: string;
  /** カード説明 */
  description: string;
  /** 表示する機能一覧 */
  features: string[];
};

defineProps<Props>();
</script>

<template>
  <RouterLink :to="to" class="settings-home-card">
    <div class="settings-home-card__header">
      <div class="settings-home-card__title-row">
        <h2 class="settings-home-card__title">{{ title }}</h2>
        <Mdi class="settings-home-card__icon" icon="keyboard_arrow_right" aria-hidden="true" />
      </div>
      <p class="settings-home-card__description">
        {{ description }}
      </p>
    </div>
    <ul class="settings-home-card__features">
      <li v-for="feature in features" :key="feature" class="settings-home-card__feature">
        <span class="settings-home-card__bullet" aria-hidden="true">・</span>
        <span class="settings-home-card__feature-text">
          {{ feature }}
        </span>
      </li>
    </ul>
  </RouterLink>
</template>

<style scoped lang="scss">
.settings-home-card {
  display: grid;
  gap: 32px;
  padding: 16px;
  border-radius: 8px;
  background-color: $semanticWhite;
  color: $textDefault;
  text-decoration: none;
  border: 1px solid $borderDefault;
  box-shadow: 0 0 22px rgba(128, 128, 128, 0.4);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  max-width: 360px;
  width: 100%;
  justify-self: start;

  &:hover {
    box-shadow: 0 2px 26px rgba(128, 128, 128, 0.45);
    transform: translateY(-2px);
  }

  &__header {
    display: grid;
    gap: 8px;
  }

  &__title-row {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    column-gap: 16px;
  }

  &__title {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: $textDefault;
    line-height: 1.3;
  }

  &__icon {
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }

  &__description {
    margin: 0;
    font-size: 16px;
    color: $textSecondary;
  }

  &__features {
    display: grid;
    gap: 16px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__feature {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 12px;
  }

  &__bullet {
    font-size: 18px;
    line-height: 1;
    color: $textSecondary;
  }

  &__feature-text {
    font-size: 16px;
    color: $textSecondary;
  }
}
</style>
